import WalletPage from './WalletPage';
import connect from './connect';

export default connect(WalletPage);



// WEBPACK FOOTER //
// ./src/app/WalletPage/index.js